import React, { useState } from 'react';

const Watches = () => {
  const [selectedWatch, setSelectedWatch] = useState(null);

  const watches = [
    {
      id: 1,
      title: "Volkswagen Beetle Watch",
      image: "/images/Watches/VW watch.jpg?height=400&width=400",
      caption: "Inspired by my 1969 VW Beetle Convertible",
    },
    {
      id: 2,
      title: "Watch for Dad",
      image: "/images/Watches/Dad Watch.jpg?height=400&width=400",
      caption: "Watch built for my father's birthday",
    },
    {
      id: 3,
      title: "DIY Watch Club Swiss Pilot",
      image: "/images/Watches/Watch Club.JPG?height=400&width=400",
      caption: "My first watch given as a graduation gift",
    }
  ];

  const openWatchModal = (watch) => {
    setSelectedWatch(watch);
  };

  const closeWatchModal = () => {
    setSelectedWatch(null);
  };

  return (
    <div className="watches-page">
      <div className="container">
        <h1 className="page-title">My Watch Collection</h1>
        <p className="page-subtitle">A collection of timepieces I've built and collected over the years</p>
        
        <div className="watches-grid">
          {watches.map((watch) => (
            <div key={watch.id} className="watch-card" onClick={() => openWatchModal(watch)}>
              <div className="watch-image">
                <img src={watch.image} alt={watch.title} />
              </div>
              <div className="watch-content">
                <h3>{watch.title}</h3>
                <p>{watch.caption}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Custom Piece Section */}
        <div className="custom-piece-section">
          <h2>Interested in a Custom Piece?</h2>
          <p>
            I love creating unique timepieces that tell a personal story. Whether you're looking for a watch 
            inspired by a special memory, vehicle, or milestone, I'd be excited to work with you to bring 
            your vision to life.
          </p>
          <div className="custom-contact">
            <a href="mailto:joe@skubic.com" className="btn btn-primary">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="email-icon">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <polyline points="22,6 12,13 2,6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              Get in Touch
            </a>
          </div>
        </div>

        {selectedWatch && (
          <div className="watch-modal" onClick={closeWatchModal}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
              <button className="close-btn" onClick={closeWatchModal}>×</button>
              
              <div className="modal-header">
                <h2>{selectedWatch.title}</h2>
                <p className="modal-caption">{selectedWatch.caption}</p>
              </div>

              <div className="modal-body">
                <div className="watch-image-large">
                  <img src={selectedWatch.image} alt={selectedWatch.title} />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Watches;
